import React from "react";
import { connect } from "react-redux";
import { createArticle } from "../../actions/yellowpage";
import {
  Container,
  Card,
  CardHeader,
  CardBody,
  Button,
  FormGroup,
  UncontrolledAlert
} from "reactstrap";
import { Link } from "react-router-dom";
import ReactCrop from "react-image-crop";
import ArticleForm from "../../components/yellowpage/ArticleForm";
import OverlayLoading from "../../components/Commons/OverlayLoading.jsx";
import moment from "moment";
import { DOMAIN } from "../../utils/constant";
import { YELLOW_CATEGORIES } from "../../utils/constant";
class YellowNewPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {
        first_category: YELLOW_CATEGORIES[0],
        category_id: YELLOW_CATEGORIES[0].sub_categories[0].id
      },
      second_categories: YELLOW_CATEGORIES[0].sub_categories,
      crop: {
        unit: "%",
        width: 50,
        height: 50
      },
      src: null,
      croppedImageUrl: null,
      editable: false
    };
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onContentChange = this.onContentChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.onImageLoaded = this.onImageLoaded.bind(this);
    this.onCropComplete = this.onCropComplete.bind(this);
    this.onCropChange = this.onCropChange.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);

    this.makeClientCrop = this.makeClientCrop.bind(this);
    this.getCroppedImg = this.getCroppedImg.bind(this);
    this.confirmImg = this.confirmImg.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
    this.handleSecondCategoryChange = this.handleSecondCategoryChange.bind(
      this
    );
    this.handleFisrtCategoryChange = this.handleFisrtCategoryChange.bind(this);
  }

  onTextInputChange(e, target) {
    let value = e.target.value;
    let article = this.state.article;
    article[target] = value;
    this.setState({
      article: article
    });
  }

  onContentChange(model) {
    let value = model;
    let article = this.state.article;
    article["body"] = value;
    this.setState({
      article: article
    });
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    let category_ids = [];
    category_ids.push(value);
    this.setState({
      article: {
        ...article,
        category_ids
      }
    });
  }

  onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
    this.setState({
      editable: true
    });
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = image => {
    this.imageRef = image;
  };

  onCropComplete = crop => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    //图片缩放
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    /**
    
     * 画布大小
     */
    // 图片原始尺寸
    var originWidth = crop.width * scaleX;
    var originHeight = crop.height * scaleY;
    // 最大尺寸限制
    var maxWidth = 2400,
      maxHeight = 2400 / (16 / 9);
    // 目标尺寸
    var targetWidth = originWidth,
      targetHeight = originHeight;
    // 图片尺寸超过最大尺寸的限制
    if (originWidth > maxWidth || originHeight > maxHeight) {
      if (originWidth / originHeight > maxWidth / maxHeight) {
        // 更宽，按照宽度限定尺寸
        targetWidth = maxWidth;
        targetHeight = Math.round(maxWidth * (originHeight / originWidth));
      } else {
        targetHeight = maxHeight;
        targetWidth = Math.round(maxHeight * (originWidth / originHeight));
      }
    }
    // canvas对图片进行缩放
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image, //原始图片
      crop.x * scaleX, //x-axis coordinate of  top left corner of source image
      crop.y * scaleY, //y-axis coordinate of top left corner of source image
      crop.width * scaleX, //the width of the sub-rectangle of the source image
      crop.height * scaleY, //the height of the sub-rectangle of the source image
      0, //x-axis coordinate in the destination canvas at which to place the top-left corner of the source image.
      0, //y-axis coordinate in the destination canvas at which to place the top-left corner of the source image.
      targetWidth, //The width to draw the image in the destination canvas. This allows scaling of the drawn image.
      targetHeight //The height to draw the image in the destination canvas. This allows scaling of the drawn image.
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        blob => {
          if (!blob) {
            console.error("Canvas is empty");
            return;
          }
          blob.name = fileName;
          this.setState({
            file: blob
          });
          window.URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = window.URL.createObjectURL(blob);
          resolve(this.fileUrl);
        },
        "image/png",
        1
      );
    });
  }

  confirmImg() {
    this.setState({
      editable: false
    });
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  handleFisrtCategoryChange(e) {
    const { value } = e.target;
    let second_categories = YELLOW_CATEGORIES[value].sub_categories;
    let article = this.state.article;
    article.category_id = second_categories[0].id;
    this.setState({
      second_categories: second_categories,
      article: article
    });
  }

  handleSecondCategoryChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    article.category_id = value;
    this.setState({
      article: article
    });
  }

  submitArticle() {
    let { file, article } = this.state;
    console.log(article);
    const category_id = article.category_id;
    const title = article.title;
    const body = article.body;
    const contact = article.contact;
    const cover_img = file;
    const email = article.email;
    const phone = article.phone;
    const address = article.address;
    const website = article.website;
    const is_promoted = article.is_promoted;
    const promo_image = article.promo_image_file;
    this.props.createArticle({
      category_id,
      title,
      body,
      cover_img,
      contact,
      email,
      phone,
      address,
      website,
      is_promoted,
      promo_image
    });
  }

  render() {
    const { crop, src, editable } = this.state;
    let {
      getArticleRequest,
      errorMsg,
      editArticleRequest
    } = this.props.yellowpage;
    const coverImg = this.state.croppedImageUrl
      ? this.state.croppedImageUrl
      : DOMAIN + "resources/cloud-upload-light.png";
    var sectionStyle = {
      width: "100%",
      paddingBottom: "60%",
      height: "0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      background:
        'url("' +
        coverImg +
        '") center center / contain no-repeat rgb(255, 255, 255)'
    };
    var fileInputStyle = {
      position: "absolute",
      opacity: 0,
      right: 0,
      top: 0,
      bottom: 0,
      left: 0,
      filter: "alpha(opacity = 0)",
      cursor: "pointer"
    };
    var uploadBtnWrapper = {
      position: "relative",
      display: "block",
      borderRadius: "6px",
      cursor: "pointer"
    };

    return (
      <Container className="mt-4" fluid>
        <Card className="card-frame">
          <CardHeader className="border-0">
            <div className="d-flex align-items-center justify-content-between">
              <div>添加黃頁</div>
              <div className="d-flex align-items-center">
                <Button
                  color="secondary"
                  tag={Link}
                  to={"/dash/admin/yellow-pages"}
                >
                  返回
                </Button>
              </div>
            </div>
          </CardHeader>
          <OverlayLoading loading={getArticleRequest}>
            <CardBody className="row">
              <div className="col-lg-8 px-4">
                {errorMsg && (
                  <UncontrolledAlert color="danger" fade={false}>
                    <span className="alert-inner--text">{errorMsg}</span>
                  </UncontrolledAlert>
                )}
                <ArticleForm
                  data={this.state.article}
                  onTextInputChange={this.onTextInputChange}
                  handleCheckBoxChange={this.handleCheckBoxChange}
                  submitArticle={this.submitArticle}
                  loading={editArticleRequest}
                  categories={YELLOW_CATEGORIES}
                  second_categories={this.state.second_categories}
                  handleFisrtCategoryChange={this.handleFisrtCategoryChange}
                  handleSecondCategoryChange={this.handleSecondCategoryChange}
                />
                <div className="col-lg-6 px-0">
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="example-date-input"
                      style={{ display: "block" }}
                    >
                      封面圖片
                    </label>
                    {src && editable && (
                      <ReactCrop
                        src={src}
                        crop={crop}
                        onImageLoaded={this.onImageLoaded}
                        onComplete={this.onCropComplete}
                        onChange={this.onCropChange}
                      />
                    )}
                    {!editable && <div style={sectionStyle}></div>}
                    <div className="d-flex flex-row">
                      {editable && (
                        <button
                          type="button"
                          className="mt-2 btn btn-default"
                          onClick={this.confirmImg}
                        >
                          確認
                        </button>
                      )}
                      <div className="mt-2" style={uploadBtnWrapper}>
                        <button
                          type="button"
                          style={{ cursor: "pointer" }}
                          block={true}
                          className="btn btn-default"
                        >
                          上傳圖片
                        </button>
                        <input
                          style={fileInputStyle}
                          type="file"
                          onChange={this.onSelectFile}
                          accept="image/x-png,image/gif,image/jpeg"
                        />
                      </div>
                    </div>
                  </FormGroup>
                </div>

                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-default"
                    style={{ flex: 1, maxWidth: "200px" }}
                    disabled={editArticleRequest}
                    onClick={this.submitArticle}
                  >
                    保存
                  </button>
                </div>
              </div>
            </CardBody>
          </OverlayLoading>
        </Card>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    yellowpage: state.yellowpage,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createArticle: params => dispatch(createArticle(params))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(YellowNewPage);
